
//
const searchResultsContainer = document.querySelector('div[data-name="search-results-container"]');

//
if (searchResultsContainer !== null) {

    //
    const zenoFetch      = require('../utils/zenoFetch.js');
    const renderTemplate = require('../utils/renderTemplate.js');
    const grecaptcha     = require('../utils/grecaptcha.js');

    //
    let search = searchResultsContainer.getAttribute('data-search-term');
    let facet = searchResultsContainer.getAttribute('data-facet');

    //
    let page = Number(searchResultsContainer.getAttribute('data-current-page'));

    //
    searchResultsContainer.addEventListener('click', function (event) {

        //
        if (event.target.matches('a[data-page], i.fa-solid.fa-chevron-right, i.fa-solid.fa-chevron-left')) {

            //
            element = event.target.closest('a[data-page]');

            //
            event.preventDefault();

            //
            page = element.getAttribute('data-page');
            searchResultsContainer.setAttribute('data-current-page', page);

            //
            loadNewResults();

        }

        //
        if (event.target.matches('a[data-facet-name]')) {

            //
            event.preventDefault();

            //
            facet = `${event.target.getAttribute('data-facet-category')}:${event.target.getAttribute('data-facet-name')}`;
            page = 1;

            //
            searchResultsContainer.setAttribute('data-current-page', 1);
            searchResultsContainer.setAttribute('data-facet', facet);

            //
            loadNewResults();

        }

        //
        if (event.target.matches('i[data-action="show-less"]')) {
            event.target.closest('.facet-category').removeAttribute('data-expanded');
        }

        //
        if (event.target.matches('i[data-action="show-more"]')) {
            event.target.closest('.facet-category').setAttribute('data-expanded', 'data-expanded');
        }

        //
        if (event.target.matches('[data-action="hide-facets"]')) {
            event.target.closest('.facets').removeAttribute('data-expanded');
        }

        //
        if (event.target.matches('[data-action="show-facets"]')) {
            event.target.closest('.facets').setAttribute('data-expanded', 'data-expanded');
        }

        //
        if (event.target.matches('[data-action="reset-facets"]')) {

            //
            event.preventDefault();

            //
            facet = '';

            //
            page = 1;
            searchResultsContainer.setAttribute('data-current-page', page)
            searchResultsContainer.setAttribute('data-facet', facet)

            //
            loadNewResults();

        }

        //
        if (event.target.matches('.search-result a')) {

            //
            const formData = new FormData();

            //
            formData.append('eventName', 'Link Clicked');
            formData.append('objectID', event.target.dataset.objectId);
            formData.append('position', parseInt(event.target.dataset.position, 10));
            formData.append('queryID', searchResultsContainer.getAttribute('data-query-id'));

            //
            navigator.sendBeacon('/api/send-algolia-event', formData);

        }

    });

    //
    if (searchResultsContainer.querySelector('input[name="grecaptcha"]')) {
        grecaptcha(searchResultsContainer.querySelector('input[name="grecaptcha"]'), (response) => {
            loadNewSearch(response);
        });
    }

    //
    async function loadNewResults() {

        //
        const [status, response] = await zenoFetch('post', '/api/get-search-results', {}, { search, page, facet });

        //
        if (status === 'success') {
            document.querySelector('div[data-name="results"]').innerHTML = renderTemplate('tpl-search-results', response);
        }

    }

    //
    async function loadNewSearch(captcha) {

        //
        const [status, response] = await zenoFetch('post', '/api/get-search-results', {}, { search, page, facet, 'captcha' : captcha });

        //
        if (status === 'success') {

            //hide the captcha
            document.querySelector('div[data-name="grecaptcha"]').setAttribute('hidden', true);

            //display the results and facets
            document.querySelector('div[data-name="results"]').removeAttribute('hidden');
            document.querySelector('div[data-name="facets"]').removeAttribute('hidden');

            //update the results + facets list
            document.querySelector('div[data-name="results"]').innerHTML = renderTemplate('tpl-search-results', response);
            document.querySelector('div[data-name="facets"]').innerHTML  = renderTemplate('tpl-facet-results',  response);

        }

    }

}